import React from 'react';
import { ChevronRight } from 'lucide-react';
export function WelcomeSection() {
  return <section className="w-full bg-background py-16 lg:py-24 relative overflow-hidden" data-id="element-186">
      {/* Subtle metallic accent line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-chrome/30 to-transparent" data-id="element-187"></div>

      <div className="max-w-[1400px] mx-auto px-4 lg:px-8" data-id="element-188">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start" data-id="element-189">
          {/* Left Column: Heading */}
          <div className="lg:w-[40%] relative" data-id="element-190">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-charcoal uppercase italic leading-none tracking-tight mb-6" data-id="element-191">
              Welcome to{' '}
              <span className="text-primary block mt-2" data-id="element-192">Pro One Design</span>
            </h2>
            <div className="hidden lg:block absolute -right-8 top-4 text-primary opacity-20" data-id="element-193">
              {/* Decorative Arrow */}
              <ChevronRight className="w-24 h-24" strokeWidth={1} data-id="element-194" />
            </div>
            {/* Mobile decorative element */}
            <div className="lg:hidden w-24 h-1 bg-primary mb-6 skew-x-[-20deg]" data-id="element-195"></div>
          </div>

          {/* Divider Line (Desktop only) */}
          <div className="hidden lg:block w-px h-40 bg-gradient-to-b from-chrome/10 via-chrome to-chrome/10 self-center" data-id="element-196"></div>

          {/* Right Column: Text */}
          <div className="lg:w-[60%]" data-id="element-197">
            <p className="text-gray-600 text-lg leading-relaxed font-sans" data-id="element-198">
              At Pro One Design, we engineer precision suspension components for
              the modern truck enthusiast. Our manufacturing process combines
              advanced technology with rugged durability to create lift kits,
              leveling kits, and accessories that perform as good as they look.
              Experience the difference of true American craftsmanship and take
              your vehicle to the next level.
            </p>
            <div className="mt-8" data-id="element-199">
              <a href="#" className="inline-flex items-center gap-2 text-primary font-heading font-bold text-xl uppercase italic hover:text-charcoal transition-colors group" data-id="element-200">
                Learn More About Us{' '}
                <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-201" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}